<template>
  <b-card v-if="!!option" id="page-suppliers-form" no-body class="mb-0">
    <b-card-header>
      <b-card-title
        ><h2>
          {{ $t(getTitle()) }} {{ $t("pages.suppliers.title").toLowerCase() }}
        </h2></b-card-title
      >
      <b-button variant="primary" @click="goBack">
        <feather-icon icon="ArrowLeftIcon" />
        {{ $t("back") }}
      </b-button>
    </b-card-header>

    <!-- <b-card-body v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </b-card-body> -->
    <b-card-body>
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <b-col cols="12" sm="12" md="6">
              <b-form-group :label="$t(label('name'))" label-for="name">
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('name'))"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="suppliers.name"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('name'))"
                    :disabled="!isSaveMode"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="12" md="6">
              <b-form-group
                :label="$t(label('email'))"
                label-for="email"
                rules="required|email"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('email'))"
                  rules="required|email"
                >
                  <b-form-input
                    id="email"
                    v-model="suppliers.email"
                    type="email"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('email'))"
                    :disabled="!isSaveMode"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="12" md="6">
              <b-form-group :label="$t(label('phone'))" label-for="phone">
                <vue-tel-input
                  inputId="phone"
                  name="phone"
                  v-model="suppliers.phone"
                  :disabled="!isSaveMode"
                  :mode="'international'"
                  defaultCountry="ve"
                  :disabledFetchingCountry="true"
                  :inputOptions="inputTelOption"
                  @open="onDropdownOpen(true)"
                  @close="onDropdownOpen(false)"
                >
                  <template v-slot:arrow-icon>
                    <span>{{ openTelInput ? "▲" : "▼" }}</span>
                  </template>
                </vue-tel-input>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="12" md="6">
              <b-form-group :label="$t(label('contact'))" label-for="phone">
                <vue-tel-input
                  inputId="contact"
                  name="contact"
                  v-model="suppliers.contact"
                  :disabled="!isSaveMode"
                  :mode="'international'"
                  defaultCountry="ve"
                  :disabledFetchingCountry="true"
                  :inputOptions="inputContactOption"
                  @open="onDropdownOpen(true)"
                  @close="onDropdownOpen(false)"
                >
                  <template v-slot:arrow-icon>
                    <span>{{ openTelInput ? "▲" : "▼" }}</span>
                  </template>
                </vue-tel-input>
              </b-form-group>
            </b-col>

            <b-col
              class="d-flex justify-content-end align-items-center"
              cols="12"
            >
              <b-button
                v-if="option != 2"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click.prevent="onSubmit"
              >
                {{ $t("save") }}
              </b-button>
              <b-button
                v-if="option == 1"
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                variant="outline-secondary"
                @click="onCancel"
              >
                {{ $t("cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-body>
  </b-card>
</template>

<script>
import _ from "lodash";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BFormCheckbox,
  BForm,
  BAlert,
  BFormSelect,
  BModal,
  BToast,
  BFormRadio,
  BFormRadioGroup,
  BFormInvalidFeedback,
  BSpinner,
} from "bootstrap-vue";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import { required, email } from "@validations";
import vSelect from "vue-select";
import { getSupplier, createOrEditSupplier } from "@core/api/request/suppliers";
import { showLoading, stopLoading } from "@core/utils/utils";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

const suppliers = {
  idSupplier: "",
  guidCompany: "",
  name: "",
  contact: "",
  phone: "",
  email: "",
};

export default {
  components: {
    BSpinner,
    BFormRadio,
    BFormRadioGroup,
    BAlert,
    BModal,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    vSelect,
    BFormSelect,
    BToast,
    BFormInvalidFeedback,
    VueTelInput,
  },
  directives: {
    Ripple,
  },
  data: () => ({
    openTelInput: false,
    isSaveMode: true,
    required,
    email,
    option: "",
    suppliers: Object.assign(suppliers),
    companies: [],
    inputTelOption: {
      placeholder: "Ingrese un número de teléfono",
      // showDialCode: true
    },
    inputContactOption: {
      placeholder: "Ingrese un número de contacto",
      // showDialCode: true
    },
    loading: true,
  }),

  computed: {},

  created() {
    localize("es");
    this.initialize();
  },

  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.suppliers.guidCompany = guid;
    },
  },

  mounted() {},

  methods: {
    label(field) {
      return `pages.suppliers.form.label.${field}`;
    },

    getTitle() {
      if (this.option === 1) return "register";
      else if (this.option === 2) return "show";
      else if (this.option === 3) return "edit";
    },

    initialize() {
      this.option = this.$route.params.option;
      if (this.option === undefined) {
        router.push({ name: "suppliers" }).catch(() => {});
      }

      switch (this.option) {
        case 1:
          this.onCancel();
          this.suppliers.guidCompany =
            this.$store.state.appConfig.activeCompanyGuid;
          break;
        case 2:
        case 3:
          if (this.$route.params.guid === undefined) {
            router.push({ name: "suppliers" }).catch(() => {});
          }
          this.isSaveMode = this.option !== 2;
          this.showSupplier(this.$route.params.guid);
          break;
      }
    },

    onSubmit() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          showLoading();
          const idSupplier =
            this.option === 1 ? null : this.suppliers.idSupplier;
          createOrEditSupplier(this.suppliers, idSupplier)
            .then(() => {
              this.goBack();
              stopLoading();
            })
            .catch((error) => {
              stopLoading();
              console.log("error", error.message);
              this.alertToast(
                "danger",
                "Error",
                error.message,
                "AlertTriangleIcon",
              );
            });
        }
      });
    },

    onDropdownOpen(isOpen) {
      this.openTelInput = isOpen;
    },

    showSupplier(idSupplier) {
      showLoading();
      getSupplier(idSupplier)
        .then((resp) => {
          const suppliers = _.get(resp, "data");
          this.suppliers = Object.assign(this.suppliers, {
            idSupplier: suppliers.idSupplier || null,
            guidCompany: suppliers.guidCompany || null,
            name: suppliers.name || null,
            contact: suppliers.contact || null,
            phone: suppliers.phone || null,
            email: suppliers.email || null,
          });
        })
        .catch((error) => {
          console.log("error", error);
          this.alertToast(
            "danger",
            "Error",
            error.message,
            "AlertTriangleIcon",
          );
        })
        .finally(() => {
          stopLoading();
        });
    },

    goBack() {
      if (this.$refs.simpleRules) {
        this.$refs.simpleRules.reset();
      }
      router.back();
      this.onCancel();
    },

    onCancel() {
      Object.assign(this.suppliers, {
        idSupplier: null,
        guidCompany: null,
        name: null,
        contact: null,
        phone: "",
        email: null,
      });
    },

    alertToast(type = null, title = null, message = null, icon) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon,
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
